var getCid = null  //用户登录进来id
if(__st.cid) {
  getCid = __st.cid
}
console.log(__st)
var language = {}
$.ajax({
  type: "get",
  url: "https://www.omnipersonalizer.com/omniBizifyPublic/manage/language/get?language=en_US",
  dataType: "json",
  async: false,
  success: function(data) {
    language = data
    console.log(data)
  },
  error: function(err) {
    console.log(err)
  }
});

//手机端，pc
var maxWidth,fixHeight,fixChildren,fixChildren2;
if ($(window).width() > 800) {
  maxWidth="800px";
  fixHeight="700px";
  fixChildren ="600px"
  fixChildren2 ="500px"
} else {
	maxWidth="90%"
    fixHeight="450px";
  	fixChildren ="380px"
    fixChildren2 ="280px"
}
var pruId=$(".scriptClass").attr("id");
var the_button = $('button[name=add]');

//===================================图片显示 ==================================
//    $(".gallery__strip").addClass("hide")  
//    var swiperProduct__gallery = '';
//       swiperProduct__gallery +='<div class="swiper-father" style="width:100%;">'+
//           '<div class="swiper-container swiper-Img" style="padding: 20px;margin-bottom:10px;">'+
//           '<div class="swiper-wrapper">';
//               $(".gallery__strip .gallery__image-wrapper").each(function() {
//                   swiperProduct__gallery +='<div class="swiper-slide">'+
//                     '<img  src='+$(this).children().attr("src")+'">'+
//             	  '</div>';
//               })
//        swiperProduct__gallery+='</div>'+
//             '</div>'+
//             '<!-- Add Pagination -->'+
//            	'<div class="swiper-pagination"></div>'+
//            	'<!-- Add Arrows -->'+
//             '<div class="swiper-button-next"></div>'+
//             '<div class="swiper-button-prev"></div>'+
//          '</div>';
//    $(".gallery__strip").before(swiperProduct__gallery)
//    var swiperImg = new Swiper('.swiper-Img', {
//      slidesPerView: 1,
//      spaceBetween: 2,
// //      loop: true,
//      pagination: {
//        el: '.swiper-pagination',
//        clickable: true,
//      },
//      navigation: {
//        nextEl: '.swiper-button-next',
//        prevEl: '.swiper-button-prev',
//      },
//    });
///////////////////////////////////////////// 功能是否开启/////////////////////////////
var enableAll = {};
$.ajax({
  type: "get",
  url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/showSet/getEnable",
  async: false,
  success: function(data) {
    console.log(data)
    enableAll = data
  },
  error: function(err) {
    console.log(err)
  }
});
// ===================================折扣价格===============================================

 var swiperHtml,discountList=[];
if(enableAll.enableDiscount){
  $.ajax({
    type: "get",
    url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/discount/list?productIdShop="+ pruId,
    dataType: "json",
    async : false,
    success: function(data) { 
      console.log(data)
      if(data != null || data.length != 0) {
        discountList = data;
        let getDiscountSelected= $("#ProductSelect-product-template option:selected").val();
        // 获取当前折扣
        getDiscountR(getDiscountSelected)
      }
    }
  })
  function getDiscountR (getDiscountSelected) {
    discountList.map(res => {
      if(getDiscountSelected == res.variantIdShop) {
        let discountTableDos = res.variantDetailPriceVos,dsvariantDetailPriceVos = res.discountCondition;;
        // 最大最小价格
          $(".maxMinPrice").remove()
          $(".product-single__meta-list").find(".product-single__price").after(`<span class="maxMinPrice" style="font-size:14px;padding-left:10px;">(${language.floorPrice}：$${res.bottomPrice}，${language.peakPrice}：$${res.price})</span>`)
          
          if(res.displayMode === 0 ) {
             $(".appFang").remove()
             console.log(res.displayMode)
             let fangHtml = `<p class="appFang">${language.priceOrderQty}:</p>
               <div class="block mt10 fc ac appFang" id="appFang" style="padding:0 20px 20px;">
                <div class="block">
					<div class="relative" style="buttom:8px;">
                    <div class="ar font12" v-for="(item, index) in discountTable" :key="index"
                      :class = "(discountTable.length === 1 ? 'w100' : (discountTable.length ===2 ?'w50' : discountTable.length ===3 ?'w33' : (discountTable.length ===4 ?'w25' : (discountTable.length ===5 ?'w20' : ''))))"
                      >
                      <div style="display:inline-block;" v-if="index == stepVal[index]">
						  <span v-if="item.discountType ===1" >{{item.currentPrice}}%</span>
                          <span v-else >{{item.currentPrice}}</span>
                        </div>
                    </div>
                  </div>
				  <div class="" style="width:120%;">&nbsp;</div>
                  <el-slider v-model="value2" @change="changeSlide" :show-tooltip="false" :step="stepInput" :min="1" :max="100" :marks="marks"></el-slider>
                </div>
              </div>
              <!-- 折扣显示类型0end -->
            </div>`
             $(".product-single__meta-list").after(fangHtml)
            // 方案1
            new Vue({
              el: '#appFang',
              data: function() {
                return { 
                    visible: false,
                    marks: {},
                    stepVal: [],
                    value2: 0,
                    stepInput: 100,
                    discountTable: discountTableDos, // 数据
                    numOrPrice: dsvariantDetailPriceVos // 价格数量类型
                }
              },
            created () {
                let _this = this
                // 第二种展示形式
                this.secondRange()
                _this.value2 = 91
              },
              methods: {
                secondRange () {
                  let _this = this
                  var sortTableDos = _this.discountTable
                  let getMarks = {1: '0'}
                  if(sortTableDos) {
                    console.log(sortTableDos)
                    sortTableDos.map((item, index) => {
                        let indexS
                        if (sortTableDos.length === 1) {
                          _this.stepInput = 90 // 步数
                          indexS = (index + 1) * 90
                        }
                        if (sortTableDos.length === 2) {
                          _this.stepInput = 45
                          indexS = (index + 1) * 45
                        }
                        if (sortTableDos.length === 3) {
                          _this.stepInput = 30
                          indexS = (index + 1) * 30
                        }
                        if (sortTableDos.length === 4) {
                          _this.stepInput = 22.5
                          indexS = (index + 1) * 22.5
                        }
                        if (sortTableDos.length === 5) {
                          _this.stepInput = 18
                          indexS = (index + 1) * 18
                        }
                        if (_this.numOrPrice === 0) {
                        // 数量
                        // eslint-disable-next-line no-unused-vars
                        getMarks[indexS] = item.number + ''
                        }
                        if (_this.numOrPrice === 1) {
                        // 金额
                        // eslint-disable-next-line no-unused-vars
                        getMarks[indexS] = item.minimumAmount + ''
                        }
                    })
                    if (sortTableDos.length === 1) {
                      _this.stepVal = [0]
                    }
                    if (sortTableDos.length === 2) {
                      _this.stepVal = [0, 1]
                    }
                    if (sortTableDos.length === 3) {
                      _this.stepVal = [0, 1, 2]
                    }
                    if (sortTableDos.length === 4) {
                      _this.stepVal = [0, 1, 2, 3]
                    }
                    if (sortTableDos.length === 5) {
                      _this.stepVal = [0, 1, 2, 3, 4]
                    }
                  }
                  _this.marks = getMarks
                  console.log(_this.marks)
                },
                changeSlide () {
                  let _this = this
                  _this.stepVal = []
                  let stepValCont1 = [0]
                  let stepValCont2 = [0, 1]
                  let stepValCont3 = [0, 1, 2]
                  let stepValCont4 = [0, 1, 2, 3]
                  let stepValCont5 = [0, 1, 2, 3, 4]
                  // eslint-disable-next-line no-unused-expressions
                  _this.discountTable.length === 1 ? _this.value2 > 1 ? _this.stepVal = stepValCont1 : '' : _this.stepVal = []
                  // eslint-disable-next-line no-unused-expressions
                  _this.discountTable.length === 2 ? (_this.value2 > 1 && _this.value2 <= 46 ? _this.stepVal = stepValCont1 : _this.stepVal = stepValCont2) : ''
                  // eslint-disable-next-line no-unused-expressions
                  _this.discountTable.length === 3 ? (_this.value2 > 1 && _this.value2 <= 31 ? _this.stepVal = stepValCont1 : (_this.value2 > 31 && _this.value2 <= 61 ? _this.stepVal = stepValCont2 : _this.stepVal = stepValCont3)) : ''
                  // eslint-disable-next-line no-unused-expressions
                  _this.discountTable.length === 4 ? _this.value2 > 1 && _this.value2 <= 23.5 ? _this.stepVal = stepValCont1 : (_this.value2 > 23.5 && _this.value2 <= 46 ? _this.stepVal = stepValCont2 : (_this.value2 > 46 && _this.value2 <= 68.5 ? _this.stepVal = stepValCont3 : _this.stepVal = stepValCont4)) : ''
                  // eslint-disable-next-line no-unused-expressions
                  _this.discountTable.length === 5 ? _this.value2 > 1 && _this.value2 <= 19 ? _this.stepVal = stepValCont1 : (_this.value2 > 19 && _this.value2 <= 37 ? _this.stepVal = stepValCont2 : (_this.value2 > 37 && _this.value2 <= 55 ? _this.stepVal = stepValCont3 : (_this.value2 > 55 && _this.value2 <= 73 ? _this.stepVal = stepValCont4 : _this.stepVal = stepValCont5))) : ''
                  // eslint-disable-next-line no-unused-expressions
                  _this.value2 <= 1 ? _this.stepVal = [] : ''
                  console.log(_this.value2, _this.stepVal)
                },
              }
            })
          } else {
             // 方案二
              $(".swiper-father").remove()
              let swiperHtml;
                swiperHtml = `
                  <div class="swiper-father" style="max-width:400px;">
                  <div class="swiper-container swiper-discount" style="padding: 20px;margin-bottom:10px;">
                  <div class="swiper-wrapper">
                  ${discountTableDos.map(item => `
                  <div class="swiper-slide border-right">
                  <div class="p10 ac ${item.minimumAmount ? '' : 'hide'}">${language.discountOrder} ${ item.minimumAmount} ${language.discountWith} ${ item.currentPrice } ${language.discountForEach}, ${item.discountPrice} ${language.discountSaved} </div>
                  <div class="p10 ac ${item.number ? '' : 'hide'}">${language.discountOrder} ${item.number} ${language.discountWith} ${ item.currentPrice } ${language.discountForEach}, ${item.discountPrice} ${language.discountSaved} </div>
                  </div>
                  `).join('')}	
                  </div>
                  </div>
                  <!-- Add Pagination -->
                  <div class="swiper-pagination"></div>
                  <!-- Add Arrows -->
                  <div class="swiper-button-next"></div>
                  <div class="swiper-button-prev"></div>
                  </div>

                  `
                $(".product-single__meta-list").after(swiperHtml)
                var swiper = new Swiper('.swiper-discount', {
                  slidesPerView: 1.1,
                  spaceBetween: 5,
                  loop: true,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                });
           }
      }
    })
  }
}

  // ==============================最小起订量=====================
 if(enableAll.enableMoq){ 
$(".shopify-payment-button").addClass('hide')
  $.ajax({  
    type : "get",  
    url : "https://www.omnipersonalizer.com/omniBizifyPublic/front/Minimum/getByProductShopId?productShopId=" +pruId,
    dataType:"json",
    async : false,
    success : function(data){  
      if(data) {
        //         1，单个sku，2，商品
        if(data.type === 2) {
          $('.product-form').before(`<p style="font-size:12px;color:red;"><span >${language.moQIs} </span>${data.quantity}</p>`)
        }
        if(data.type === 1) {
          $('.product-form').before(`<p style="font-size:12px;color:red;"><span >${language.moQIsV} </span>${data.quantity}</p>`)
        }
      }
      console.log(data.type === 2,data.type === 1,'======================'+data.quantity+'================')
    },
    error: function(err){
      console.log(err)

    }
  }); 
}
// ===================================样品===============================================
if(enableAll.enableSample){ 
$.ajax({  
    type : "get",  
    url : "https://www.omnipersonalizer.com/omniBizifyPublic/front/sample/getByProductIdShop?productIdShop=" +pruId,
    dataType:"json",
    async : false,
    success : function(data){  
      if(data) {
        if(data) {
          product_formsubmit.css('display', 'block')
          $(".setLs").remove()
          $(".shopify-payment-button").before('<a  data-handle="{{product.handle}}" data-product="{{product.id}}" id="customify-link"   class="shopify-payment-button__button shopify-payment-button__button--unbranded"'
          +'href="https://'+data.productUrl+'"'+' style="margin:10px 0; background:'+data.buttonColor+';color:#fff">'+data.buttonText+'</a>') 
        }
      }
      console.log(data)
    },
    error: function(err){
      console.log(err)

    }
  }); 
}
//===================================== tag标签=====================================
if(enableAll.enableContent){ 
$.ajax({
  type: "get",
  url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/label/getByProductIdShop?productIdShop=" +pruId,
  dataType: "json",
  async: false,
  success: function(data) {
    console.log(data)
    if(data.length >= 0) {
      let tag =  `
          <div>
            <div class="el-rabs__header">
              <div class="el-tabs__nav" style="transform: translateX(0px);">
                <div class="el-tabs__active-bar" style="transform: translateX(0px);"></div>
                ${data.map((item,dataid) => `
                  <div class="el-tabs__item" data-id="${dataid}">${item.name}</div>
                `).join('')}  
               </div>
            </div>
			<div class="el-tabs__contentAll">
              ${data.map((item,dataid) => `
              	<div class = "el-tabs__content hide">${item.description}</div>
              `).join('')}  
            </div>
          </div>
      `
      $("#shopify-section-product-template").after(tag)
    }
  },
  error: function(err) {
    console.log(err)
  }
});

$(".el-tabs__active-bar").css({
  "width": $(".el-tabs__item").eq(0).width() + "px"
})
$(".el-tabs__item").eq(0).addClass("el-is-active")
$(".el-tabs__content").eq(0).removeClass("hide")
$(document).on("click",".el-tabs__item",function(){
  if(!$(this).hasClass("el-is-active")) {
    $(this).addClass("el-is-active").siblings(".el-tabs__item").removeClass("el-is-active")
    let dataId = $(this).attr("data-id")
    let transPosition = 0;
    if(dataId == 0) {
      transPosition = 0
    } else {
      $(".el-tabs__item").each(function(i) {
        if(dataId > i){
          transPosition += $(this).width() + 45
        }
      })
    }
    $(".el-tabs__active-bar").css({"width": $(this).width()+ "px", "transform": "translateX("+transPosition+"px)"})
    $(".el-tabs__content").each(function() {
      $(this).addClass("hide");
    })
    $(".el-tabs__content").eq(dataId).removeClass("hide");
  } 
})  
}
  // ==============================选择数量=====================
  var getInfo = {},
      getLoginInfo = {}, //登录信息
      getProduct = [],
      getSku,
      shopifyVariant = $("#ProductSelect-product-template option:selected").val(),
      addCartNumber = 1;
  $(".selector-wrapper").change(function(){
    shopifyVariant = $("#ProductSelect-product-template option:selected").val()
    console.log(shopifyVariant)
    // 获取折扣信息
      if(enableAll.enableDiscount) {
      	getDiscountR (shopifyVariant)
      }
    //获取自定义
//     ;
  }) 
//   数量
//   $(".js-qty__input").change(function(){
//     addCartNumber = $(".js-qty__input").val();
//     ;
// })
//   $(".js-qty__adjust").click(function(){
//     setTimeout(function(){
//     	addCartNumber = $(".js-qty__input").val();
//     	;
//     },200)
//   }) 
  var attrClass = the_button.attr('class')
  // ===================================自定义===============================================

//   var background="",
//      color="",
//      hoverBackground="",
//      hoverColor="";
//      textWord="Customize Now";
//   $.ajax({  
//     type : "get",  
//     url : "https://www.omnipersonalizer.com/front/cus/get",  
//     dataType:"json",
//     async : false,
//     success : function(data){  
//       console.log(data)
//       textWord=data.text;
//       background=data.background;
//       color=data.color;
//       hoverBackground=data.hoverBackground;
//       hoverColor=data.hoverColor;
//     },
//     error: function(err){
//       console.log(err)

//     }
//   }); 
// 	;
//   function text(shopifyVar,addCartNumber) {
//     console.log(shopifyVar)
    
//     jQuery.getJSON('https://www.omnipersonalizer.com/personality/front/product/getCustomizationStatus?productIdShopify=' +pruId, function(result){
//     console.log(result);
//     if ( result.customizationStatus == "yes" ){
//           the_button.addClass("hide");
//           $("#customify-link").remove();
//             if(shopifyVar!==undefined){
//                 the_button.after('<a  data-handle="{{product.handle}}" data-product="{{product.id}}" id="customify-link"   class="'+attrClass+' shopifyHref product-form__add-to-cart"'
//                 +'href="https://'+window.location.host+'/apps/pages/indexAll.html?id='+pruId+'&variant='+shopifyVar+'&addCartNumber='+addCartNumber+'"'
//                 +' style="background:'+background+';color:'+color+'">'+textWord+'</a>')    
//              } else {
//                the_button.after('<a  data-handle="{{product.handle}}" data-product="{{product.id}}" id="customify-link"  class="'+attrClass+' btn product-form__add-to-cart">Sold out</a>')                                     
//              }
          
            
//           } else {
//           $('form[action="/cart/add"] *[type="submit"]').show();
//         }
//      })
//   }
//   $(document).on('mouseover','.shopifyHref',function(){
//     $(this).css({background:hoverBackground,color:hoverColor})
//   })
//   $(document).on('mouseout','.shopifyHref',function(){
//     $(this).css({background:background,color:color})
//   })
  //====================是否显示询单===============================================
   if(enableAll.enableInquiry) {
      $.ajax({
        type: "get",
        url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/product/getInquiry?productIdShop=" + pruId,
        dataType: "json",
        success: function(data) {   //是否显示询单
          if(data) {
          	$.ajax({
              type: "get",
              url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/showSet/get",
              dataType: "json",
              success: function(response) { // 是否并存购物车
                product_formsubmit.css('display', 'block')
                $(".setLs").remove()
                if(!response.andCart) {
	$(".shopify-payment-button").addClass('hide')
                  the_button.before(`<span class="${attrClass} inquiry mb10" style="background:#4395ff;color:#fff;margin-bottom:10px;display:block;">${response.showInquiryText}</span>`)
                } else {
                  the_button.addClass('hide')
                  $(".shopify-payment-button").addClass('hide')
                  the_button.before(`<span class="${attrClass} inquiry mb10" style="background:#4395ff;color:#fff;margin-bottom:10px;display:block;">${response.showInquiryText}</span>`)
                }

              }
            })
          }
          console.log(data)
        },
        error: function(err) {
          console.log(err)
        }
      });
    }
      //用户登录获取信息
      if(getCid) {
        $.ajax({
          type: "get",
          url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/customer/getByCustomerIdShop?customerIdshop=" + getCid,
          dataType: "json",
          async: false,
          success: function(data) {
            if(data) {
              getLoginInfo=data
            }
            console.log(data)
          },
          error: function(err) {
            console.log(err)
          }
        });
      }
      
      
      // 点击询盘
      $(document).on('click', '.inquiry', function() {
        console.log(333)
        $.ajax({
          type: "get",
          url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/product/getByProductIdShop?productIdShop=" + pruId,
          dataType: "json",
          async: false,
          success: function(data) {
            getProduct = data
            if(data) {
              data.variantFrontVoList.forEach(function(item){
                if(item.variantIdShop == shopifyVariant) {
                  getSku = item.sku
                  console.log(getSku)
                }
              })
            }
          },
          error: function(err) {
            console.log(err)
          }
        });
        console.log(getSku,shopifyVariant)
        $(".modelProduct").removeClass('hide')
        $.ajax({
          type: "get",
          url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/customerForm/get",
          dataType: "json",
          success: function(data) {
            console.log(data)
            getInfo = data;
            let innerHtml = `
              <div class="modelProduct">
				<div  class="el-form el-formFirst" style="width:${maxWidth}; height:${fixHeight} !important">
                  <div class="overflowY" style="height:${fixChildren} !important">
					<p  class="p0" style="padding:0;margin:0;"><img  src="https://www.omnipersonalizer.com${getInfo.imageUrl}" width="100%" alt="" style="max-height: 300px;"></p> 
                    <div  class="ov relative_30 boxShadow back_white">
					  <p class="${getInfo.businessName ? '' : 'hide'} font18 blod mb10">${getInfo.businessName}</p> 
                      <p class="${getInfo.title ? '' : 'hide'} blod font16" >${getInfo.title}</p> 
                      <p class="${getInfo.description ? '' : 'hide'} italic">${getInfo.description}</p> 
					  <p class="${getInfo.info ? '' : 'hide'}">${language.infoFrom}：${getInfo.info}</p>
                      <div class="${getInfo.cusName==0 ? 'hide' : ''}">
                        <div class="el-input-border cusName2 ${getInfo.fullName ? '' : 'hide'}">
						  <p >${language.fullName}<span class="color_red ${getInfo.cusName==2 ? '' : 'hide'}" >*</span></p> 
                          <div  class="el-input">
							<input type="text"  value="${getLoginInfo.fullName ? getLoginInfo.fullName: ''}" autocomplete="off" placeholder="${language.enterFullName}" class="el-input__inner ">
                          </div>
                        </div>
 			            <div class="el-form-item__error hide">${language.enterFullName}</div>

						<div class="s_firstName el-input-border  ${!getInfo.fullName ? '' : 'hide'}">
                          <p >${language.firstName} <span class="color_red ${getInfo.cusName==2 ? '' : 'hide'}" >*</span></p> 
                          <div  class="el-input">
                          	<input type="text" value="${getLoginInfo.firstName ? getLoginInfo.firstName: ''}" autocomplete="off" placeholder="${language.enterFirstName}" class="el-input__inner ">
                          </div>
						</div>
                        <div class="el-form-item__error hide">${language.enterFirstName}</div>

                        <div class="s_lastName el-input-border  ${!getInfo.fullName ? '' : 'hide'}">
                          <p >${language.lastName} <span class="color_red ${getInfo.cusName==2 ? '' : 'hide'}" >*</span></p> 
                          <div  class="el-input">
                            <input type="text" value="${getLoginInfo.lastName ? getLoginInfo.lastName: ''}" autocomplete="off" placeholder="${language.enterLastName}" class="el-input__inner ">
                          </div>
						</div>
						<div class="el-form-item__error hide">${language.enterLastName}</div>
                      </div>
                      <div class="el-input-border cusCity  ${getInfo.cusCity !== 0 ? '' : 'hide'}" >
                        <p >${language.city} <span class="color_red ${getInfo.cusCity==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterCity}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterCity}</div>
                      <div class="el-input-border cusZip ${getInfo.cusZip !== 0 ? '' : 'hide'}" >
                        <p >${language.postCode}<span class="color_red ${getInfo.cusZip==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterPostCode}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterPostCode}</div>
                      <div class="el-input-border cusState ${getInfo.cusState !== 0 ? '' : 'hide'}">
                        <p >${language.state}<span class="color_red ${getInfo.cusState==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterState}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterState}</div>
                      <div class="el-input-border cusCountry ${getInfo.cusCountry !== 0 ? '' : 'hide'}">
                        <p >${language.country} <span class="color_red ${getInfo.cusCountry==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterCountry}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterCountry}</div>
                      <div class="el-input-border cusPhone ${getInfo.cusPhone !== 0 ? '' : 'hide'}">
                        <p >${language.phone} <span class="color_red ${getInfo.cusPhone==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterPhone}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterPhone}</div>
                      <div class="el-input-border cusMail ${getInfo.cusMail !== 0 ? '' : 'hide'}">
                        <p >${language.mail} <span class="color_red ${getInfo.cusMail==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" value="${getLoginInfo.email ? getLoginInfo.email : ""}" autocomplete="off" placeholder="${language.enterEmail}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterEmail}</div>
                      <div class="el-input-border cusBusinessName ${getInfo.cusBusinessName !== 0 ? '' : 'hide'}" >
                        <p >${language.businessName}<span class="color_red ${getInfo.cusBusinessName==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text"  autocomplete="off" placeholder="${language.enterCorporateName}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterCorporateName}</div>
                      <div class="el-input-border cusWorkMail ${getInfo.cusWorkMail !== 0  ? '' : 'hide'}">
                        <p >${language.workMail} <span class="color_red ${getInfo.cusWorkMail==2 ? '' : 'hide'}" >*</span> </p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterWorkEmail}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterWorkEmail}</div>
                      <div class="el-input-border cusJob ${getInfo.cusJob !== 0  ? '' : 'hide'}">
                        <p >${language.jobTitle} <span class="color_red ${getInfo.cusJob==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterJobTitle}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterJobTitle}</div>
                      <div class="el-input-border cusWorkPhone ${getInfo.cusWorkPhone !== 0 ? '' : 'hide'}">
                        <p >${language.workPhone} <span class="color_red ${getInfo.cusWorkPhone==2 ? '' : 'hide'}" >*</span></p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterWorkTel}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterWorkTel}</div>
                      <div class="el-input content">
                        <p >${language.content}</p> 
                        <div  class="el-input">
                          <textarea autocomplete="off" rows="6" placeholder="${language.enterConter}" class="el-textarea__inner borderDc w100" style="min-height: 33px;"></textarea>
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterConter}</div>
                    <!-- 这里是是否有enquiry -->
                    <div class="${getInfo.enquiry ? '' : 'hide'}">
                      <div class="el-input productName">
                        <p >${language.product}</p> 
                        <div  class="el-input">
                            <input type="text" autocomplete="off" placeholder="${language.enterProduct}" value="${getProduct.productName}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-input flex flex_center">
                        <p >${language.productPicture}<img src="${getProduct.productPicture}" class="productPicture" width="40px" height:"40px"/></p> 
                      </div>
					  <div class="el-form-item__error hide">${language.enterProduct}</div>
                      <div class="el-input productSku">
                        <p >SKU</p> 
                        <div  class="el-input">
                          <input type="text" autocomplete="off" placeholder="${language.enterSku}" value="${getSku}" class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterSku}</div>
                      <div class="amount">
						<p >${language.number}</p> 
                        <div  class="el-input">
                          <input type="number"  autocomplete="off" placeholder="${language.enterNumber}" value="1"  class="el-input__inner">
                        </div>
                      </div>
                      <div class="el-form-item__error hide">${language.enterNumber}</div>
                    </div>
				   </div>
				  </div>
					<div class="justifyCenter mt20 rwelativeBottom">
					  
                       <div  class="btn benNo btnAccent footer__newsletter-submit  mr20" >${language.cancel}</div> 
						<div class="btn  nexBtnSure btnAccent footer__newsletter-submit ${getInfo.questionVos ? '' : 'hide'}"  style="background-color: #1990c6;color:#fff;">${language.nextPage}</div>
                   	  <div class="btn btnSure  btnAccent footer__newsletter-submit ${getInfo.questionVos ? 'hide' : ''}"  style="background-color: #1990c6;color:#fff;">${language.sure}</div>
                    </div>
                </div>
                <div class="el-form el-formSecond hide p20" style="width:${maxWidth}; height:${fixHeight} !important"> 
				  <h3 class="ac">${language.enterQuestionnaire}</h3>
                  <div class="overflowY p20" style="height:${fixChildren2} !important">
                    ${getInfo.questionVos.map((askItem,ix) => `
                      ${(function(){
                        if(askItem.questionType === 0){
                          return `<div>
                            <p>${ix+1}. ${askItem.question}</p>
                            <div><textarea autocomplete="off" rows="3" name="${askItem.id}"  placeholder="${language.enterComments}"  class="el-textarea__inner borderDc w100" ></textarea></div>
                            <div class="el-form-item__error hide">${language.enterComments}</div>
                            </div>`;
                        }else if(askItem.questionType === 2){
                          return `<div><p>${ix+1}. ${askItem.question}</p>
                            <div>
                              ${askItem.optionsVos.map(askRadio => `
                              <input  type="checkbox" name="${askItem.id}" value="${askRadio.content}"><span class="mlr10 font14 elColor">${askRadio.content}</span>
                              `).join('')}
							  </div><div class="el-form-item__error hide">${language.unselected}</div></div>`;
                        } else {
                          return `<div>
                          <p>${ix+1}. ${askItem.question}</p>
                          <div>
                            ${askItem.optionsVos.map(askRadio => `
                              <input  type="radio" name="${askItem.id}" value="${askRadio.content}"><span class="mlr10 font14 elColor">${askRadio.content}</span>
                            `).join('')}
                          </div><div class="el-form-item__error hide">${language.unselected}</div></div>`;
                        }
                      })()
                      }
                    `).join('')}
                    <div class="justifyCenter mt20 rwelativeBottom">
                      <div class="btn  btnAccent preBtnSure footer__newsletter-submit mr20 ">${language.previousPage}</div>
                      <div class="btn btnSure  btnAccent footer__newsletter-submit" style="background-color: #1990c6;color:#fff;">${language.sure}</div>
                    </div>
                  </div>
                </div>
              </div>
              `
            $('body').append(innerHtml);
          },
          error: function(err) {
            console.log(err)
          }
        });
      })
      //   取消
      $(document).on('click', '.benNo', function() {
        $(".modelProduct").addClass('hide')
      })
	  // 下一页
      $(document).on('click', '.nexBtnSure', function () {
        let canSave=true;
        let reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/; 
        let phoneReg = /^1[34578]\\d{9}$/;
        $(".el-input-border").removeClass("el-error");
        // 名称s_firstName
        getInfo.cusName == 2 && $(".s_firstName .el-input__inner").val().length<=0 && !getInfo.fullName ? ($(".s_firstName").next().removeClass("hide"), $(".s_firstName").addClass("el-error"), canSave = false) : $(".s_firstName").next().addClass("hide");
         // 名称s_lastName
        getInfo.cusName == 2 && $(".s_lastName .el-input__inner").val().length<=0 && !getInfo.fullName ? ($(".s_lastName").next().removeClass("hide"), $(".s_lastName").addClass("el-error"), canSave = false) : $(".s_lastName").next().addClass("hide");
        //全称
        getInfo.cusName == 2 && $(".cusName2 .el-input__inner").val().length<=0 && getInfo.fullName ? ($(".cusName2").next().removeClass("hide"), $(".cusName2").addClass("el-error"), canSave = false) : $(".cusName2").next().addClass("hide");
        // 电话
        getInfo.cusPhone == 2 && $(".cusPhone .el-input__inner").val().length<=0 ? ($(".cusPhone").next().removeClass("hide"), $(".cusPhone").addClass("el-error"), canSave = false) : $(".cusPhone").next().addClass("hide") ;
        // 邮箱
        getInfo.cusMail == 2 && $(".cusMail .el-input__inner").val().length<=0 ? ($(".cusMail").next().removeClass("hide").text(language.mailEmpty), $(".cusMail").addClass("el-error"), canSave = false) : $(".cusMail").next().addClass("hide");
        getInfo.cusMail == 2 && !$(".cusMail .el-input__inner").val().match(reg) ? ($(".cusMail").next().removeClass("hide").text(language.correctEmail), $(".cusMail").addClass("el-error"), canSave = false) : $(".cusMail").next().addClass("hide");
        // 公司名称
        getInfo.cusBusinessName == 2 && $(".cusBusinessName .el-input__inner").val().length<=0 ? ($(".cusBusinessName").next().removeClass("hide"), $(".cusBusinessName").addClass("el-error"), canSave = false) : $(".cusBusinessName").next().addClass("hide");
        // 城市
        getInfo.cusCity == 2 && $(".cusCity .el-input__inner").val().length<=0 ? ($(".cusCity").next().removeClass("hide"), $(".cusCity").addClass("el-error"), canSave = false) : $(".cusCity").next().addClass("hide");
        // 国家
        getInfo.cusCountry == 2 && $(".cusCountry .el-input__inner").val().length<=0 ? ($(".cusCountry").next().removeClass("hide"), $(".cusCountry").addClass("el-error"), canSave = false) : $(".cusCountry").next().addClass("hide");
        // 职位
        getInfo.cusJob == 2 && $(".cusJob .el-input__inner").val().length<=0 ? ($(".cusJob").next().removeClass("hide"), $(".cusJob").addClass("el-error"), canSave = false) : $(".cusJob").next().addClass("hide");
        // 州（省）
        getInfo.cusState == 2 && $(".cusState .el-input__inner").val().length<=0 ? ($(".cusState").next().removeClass("hide"), $(".cusState").addClass("el-error"), canSave = false) : $(".cusState").next().addClass("hide");
        // 工作邮箱
        getInfo.cusWorkMail == 2 && $(".cusWorkMail .el-input__inner").val().length<=0 ? ($(".cusWorkMail").next().removeClass("hide"), $(".cusWorkMail").addClass("el-error"), canSave = false) : $(".cusWorkMail").next().addClass("hide");
        getInfo.cusWorkMail == 2 && !$(".cusWorkMail .el-input__inner").val().match(reg) ? ($(".cusWorkMail").next().removeClass("hide").text(language.correctEmail), $(".cusWorkMail").addClass("el-error"), canSave = false) : $(".cusWorkMail").next().addClass("hide");
        // 工作电话
        getInfo.cusWorkPhone == 2 && $(".cusWorkPhone .el-input__inner").val().length<=0 ? ($(".cusWorkPhone").next().removeClass("hide"), $(".cusWorkPhone").addClass("el-error"), canSave = false) : $(".cusWorkPhone").next().addClass("hide");
        // 邮编
        getInfo.cusZip == 2 && $(".cusZip .el-input__inner").val().length<=0 ? ($(".cusZip").next().removeClass("hide"), $(".cusZip").addClass("el-error"), canSave = false) : $(".cusZip").next().addClass("hide");
        let getnumId = null
        if(getInfo.fullName == false) {
          getnumId = 1
        }
        if(getInfo.fullName == true) {
          getnumId = 2
        }
        if(canSave) {
          $(".el-formFirst").addClass('hide')
          $(".el-formSecond").removeClass('hide')
        }
      })
      // 上一页
      $(document).on('click', '.preBtnSure', function () {
        $(".el-formFirst").removeClass('hide')
        $(".el-formSecond").addClass('hide')
      })
      //   确定
      $(document).on('click', '.btnSure', function() {
        let canSave=true;
        let reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/; 
        let phoneReg = /^1[34578]\\d{9}$/;
        $(".el-input-border").removeClass("el-error");
        // 名称s_firstName
        getInfo.cusName == 2 && $(".s_firstName .el-input__inner").val().length<=0 && !getInfo.fullName ? ($(".s_firstName").next().removeClass("hide"), $(".s_firstName").addClass("el-error"), canSave = false) : $(".s_firstName").next().addClass("hide");
         // 名称s_lastName
        getInfo.cusName == 2 && $(".s_lastName .el-input__inner").val().length<=0 && !getInfo.fullName ? ($(".s_lastName").next().removeClass("hide"), $(".s_lastName").addClass("el-error"), canSave = false) : $(".s_lastName").next().addClass("hide");
        //全称
        getInfo.cusName == 2 && $(".cusName2 .el-input__inner").val().length<=0 && getInfo.fullName ? ($(".cusName2").next().removeClass("hide"), $(".cusName2").addClass("el-error"), canSave = false) : $(".cusName2").next().addClass("hide");
        // 电话
        getInfo.cusPhone == 2 && $(".cusPhone .el-input__inner").val().length<=0 ? ($(".cusPhone").next().removeClass("hide"), $(".cusPhone").addClass("el-error"), canSave = false) : $(".cusPhone").next().addClass("hide") ;
        // 邮箱
        getInfo.cusMail == 2 && $(".cusMail .el-input__inner").val().length<=0 ? ($(".cusMail").next().removeClass("hide").text(language.mailEmpty), $(".cusMail").addClass("el-error"), canSave = false) : $(".cusMail").next().addClass("hide");
        getInfo.cusMail == 2 && !$(".cusMail .el-input__inner").val().match(reg) ? ($(".cusMail").next().removeClass("hide").text(language.correctEmail), $(".cusMail").addClass("el-error"), canSave = false) : $(".cusMail").next().addClass("hide");
        // 公司名称
        getInfo.cusBusinessName == 2 && $(".cusBusinessName .el-input__inner").val().length<=0 ? ($(".cusBusinessName").next().removeClass("hide"), $(".cusBusinessName").addClass("el-error"), canSave = false) : $(".cusBusinessName").next().addClass("hide");
        // 城市
        getInfo.cusCity == 2 && $(".cusCity .el-input__inner").val().length<=0 ? ($(".cusCity").next().removeClass("hide"), $(".cusCity").addClass("el-error"), canSave = false) : $(".cusCity").next().addClass("hide");
        // 国家
        getInfo.cusCountry == 2 && $(".cusCountry .el-input__inner").val().length<=0 ? ($(".cusCountry").next().removeClass("hide"), $(".cusCountry").addClass("el-error"), canSave = false) : $(".cusCountry").next().addClass("hide");
        // 职位
        getInfo.cusJob == 2 && $(".cusJob .el-input__inner").val().length<=0 ? ($(".cusJob").next().removeClass("hide"), $(".cusJob").addClass("el-error"), canSave = false) : $(".cusJob").next().addClass("hide");
        // 州（省）
        getInfo.cusState == 2 && $(".cusState .el-input__inner").val().length<=0 ? ($(".cusState").next().removeClass("hide"), $(".cusState").addClass("el-error"), canSave = false) : $(".cusState").next().addClass("hide");
        // 工作邮箱
        getInfo.cusWorkMail == 2 && $(".cusWorkMail .el-input__inner").val().length<=0 ? ($(".cusWorkMail").next().removeClass("hide"), $(".cusWorkMail").addClass("el-error"), canSave = false) : $(".cusWorkMail").next().addClass("hide");
        getInfo.cusWorkMail == 2 && !$(".cusWorkMail .el-input__inner").val().match(reg) ? ($(".cusWorkMail").next().removeClass("hide").text(language.correctEmail), $(".cusWorkMail").addClass("el-error"), canSave = false) : $(".cusWorkMail").next().addClass("hide");
        // 工作电话
        getInfo.cusWorkPhone == 2 && $(".cusWorkPhone .el-input__inner").val().length<=0 ? ($(".cusWorkPhone").next().removeClass("hide"), $(".cusWorkPhone").addClass("el-error"), canSave = false) : $(".cusWorkPhone").next().addClass("hide");
        // 邮编
        getInfo.cusZip == 2 && $(".cusZip .el-input__inner").val().length<=0 ? ($(".cusZip").next().removeClass("hide"), $(".cusZip").addClass("el-error"), canSave = false) : $(".cusZip").next().addClass("hide");
        let getnumId = null
        if(getInfo.fullName == false) {
          getnumId = 1
        }
        if(getInfo.fullName == true) {
          getnumId = 2
        }
        
//         问券调查
        let resultQuestionDos=[] // 问券调查结果
        
        $.ajax({
        type: "get",
        url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/customerForm/get",
        dataType: "json",
        async:false,
        success: function (data) {
          if(data.questionVos.length>0){
            data.questionVos.map((askItem,ix) =>{
                let aaa={}
                aaa.id="";
                aaa.questionId=askItem.id;
                aaa.question=askItem.question;
                questionId = askItem.questionId;
                if(askItem.questionType===0) {
                  if($("textarea[name="+askItem.id+"]").val()){
                    aaa.content = $("textarea[name="+askItem.id+"]").val();
                    $("textarea[name="+askItem.id+"]").parent().siblings('.el-form-item__error').addClass('hide')
                    canSave = true
                  } else {
                    $("textarea[name="+askItem.id+"]").parent().siblings('.el-form-item__error').removeClass('hide')
                    canSave = false
                  }
                } else if(askItem.questionType===1) {
                  if($("input[name="+askItem.id+"]:checked").val()) {
                    aaa.content = $("input[name="+askItem.id+"]:checked").val();
                    $("input[name="+askItem.id+"]").parent().siblings('.el-form-item__error').addClass('hide')
                    canSave = true
                  } else {
                    $("input[name="+askItem.id+"]").parent().siblings('.el-form-item__error').removeClass('hide')
                    canSave = false
                  }
                } else {
                  var arr_v = []; 
                  $("input[name="+askItem.id+"]:checked").each(function(){ 
                    arr_v.push($(this).val()); 
                  }); 
                  if(arr_v.length>0) {
                    aaa.content = arr_v.toString();
                    $("input[name="+askItem.id+"]").parent().siblings('.el-form-item__error').addClass('hide')
                    canSave = true
                  } else {
                    $("input[name="+askItem.id+"]").parent().siblings('.el-form-item__error').removeClass('hide')
                    canSave = false
                  }
                }
                resultQuestionDos.push(aaa)
            })
          }
        }
      })
        let saveCon = {
          "amount": $(".amount .el-input__inner").val(),
          "businessName": $(".cusBusinessName .el-input__inner").val(),
          "city": $(".cusCity .el-input__inner").val(),
          "content": $(".content .el-textarea__inner").val(),
          "country": $(".cusCountry .el-input__inner").val(),
          "cusZip": $(".cusZip .el-input__inner").val(),
          "customerIdShop": getCid,
          "variantIdShop": shopifyVariant,
          "jobTitle": $(".cusJob .el-input__inner").val(),
          "mail": $(".cusMail .el-input__inner").val(),
          "name": $(".cusName2 .el-input__inner").val(),
          "lastName":$(".s_lastName .el-input__inner").val(),
          "firstName":$(".s_firstName .el-input__inner").val(),
          "phone": $(".cusPhone .el-input__inner").val(),
          "state": $(".cusState .el-input__inner").val(),
          "workMail": $(".cusWorkMail .el-input__inner").val(),
          "workPhone": $(".cusWorkPhone .el-input__inner").val(),
          "enquiry": getInfo.enquiry,
          "productPicture": $(".productPicture").attr('src'),
          "productTitle": $(".productName .el-input__inner").val(),
          "sku": getSku,
          "resultQuestionDos": resultQuestionDos
        }
        console.log(canSave)
//         console.log(saveCon)
        if(canSave) {
          $.ajax({  
            type : "post",  
            url : "https://www.omnipersonalizer.com//omniBizifyPublic/front/tableConent/save",
            data: JSON.stringify(saveCon),
            contentType: "application/json;charset=UTF-8",
            success : function(data){  
              console.log(data)
              $(".modelProduct").addClass('hide')
              $.ajax({
                type: "get",
                url: "https://www.omnipersonalizer.com/omniBizifyPublic/front/sbuForm/get",
                dataType: "json",
                success: function(response) {
                  let showSureBtn = `
                  <!-- 这里是点击确认之后显示内容 -->
                  <div class="showBtnSure">
                      <form  class="el-form2 ac boxShadow ptb50">
                          <p  class=" font40 color_green p0"><img src="https://www.omnipersonalizer.com/omniBizifyPublic/media/img/default/1599643375413.png"/></p> 
                          <p  class="color_green pt10 p0">${response.title}</p> 
                          <p >${response.description}</p> 
                          <a  href="${response.url}"><button  type="button" class="el-button largeBtn el-button--default el-button--mini is-round"><span>
                          <img  src="https://www.omnipersonalizer.com/omniBizifyPublic/media/img/default/1599643294942.png"class="el-icon-s-promotion mr10">${response.website}</span></button></a>
                      </form>
                  </div>
                  `
                  $('body').append(showSureBtn);
                }
              })
            },
            error: function(err){
              console.log(err)
            }
          });
        }        
      })

                  


       
      
      
      
      
      
      
    

      
      
      